import instance from "../../utils/axios"; // path to your axios file

// Fetch All or by ID
export const fetchChannels = async (payload = {}) => {
  const formData = new URLSearchParams();
  Object.entries(payload).forEach(([key, val]) => {
    if (val !== undefined && val !== null) {
      formData.append(key, val);
    }
  });
  if (!formData.has("typeofentity")) {
    formData.append("typeofentity", "2");
  }

  const response = await instance.post("/churches/readcms", formData);
  return response.data;
};

// Save Channel
export const saveChannel = async (inputs) => {
  const formData = new URLSearchParams();
  Object.entries(inputs || {}).forEach(([key, val]) =>
    formData.append(key, val || "")
  );

  const response = await instance.post("/churches/save", formData);
  return response.data;
};

// Delete Channel
export const deleteChannel = async (_id) => {
  const formData = new URLSearchParams();
  formData.append("_id", _id);

  const response = await instance.post("/churches/delete", formData);
  return response.data;
};

// Update Channel
export const updateChannel = async (inputs) => {
  const formData = new URLSearchParams();
  Object.entries(inputs || {}).forEach(([key, val]) =>
    formData.append(key, val || "")
  );

  const response = await instance.post("/churches/update", formData);
  return response.data;
};

// Fetch Channel by ID
export const fetchChannelById = async (_id) => {
  const formData = new URLSearchParams();
  formData.append("typeofentity", "2");
  formData.append("_id", _id);

  const response = await instance.post("/churches/readcms", formData);
  return response.data;
};
